import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ptBr from "date-fns/locale/pt-BR";
import InputMask from 'react-input-mask';
import moment from 'moment';
import CustomInput from './CustomInput';
import CustomInputLabelExterno from './CustomInputLabelExterno';

// `parse` (opcional): leitura própria do valor. O padrão é o moment tolerante de sempre, que
// transforma data inexistente em outra (31/02/2026 → 20/02/2031); quem valida a data passa um
// parse estrito para o campo mostrar o que foi digitado (Painel Financeiro, C05).
// `maxDate` (opcional): o calendário não deixa escolher depois dela. Digitar ainda passa, então quem
// usa valida também (ex.: o Fechamento do evento, que não aceita data futura).
export default function Data({ id = null, inputName = null, label = "Data", value, onChange = null, placeholder = "Data", title = "", readOnly = false, disabled = null, labelExterno = false, className = "", withPortal = false, required = false, autoComplete = undefined, inputStyle = null, wrapperClassName = "", parse = null, maxDate = null }) {
    var parseableValue = value && !String(value).includes('_') ? value : null;
    var parsed = parseableValue ? (parse ? parse(parseableValue) : moment(parseableValue, ["DD/MM/YYYY", "YYYY-MM-DD"])) : null;
    var selected = null;

    if (parsed && parsed.isValid()) {
        selected = parsed.toDate();
    }

    return (
        <DatePicker
            required={required}
            disabled={disabled}
            id={id}
            title={title}
            readOnly={readOnly}
            wrapperClassName={wrapperClassName || undefined}
            value={parsed && parsed.isValid() ? parsed.format("DD/MM/YYYY") : (value || '')}
            selected={selected}
            locale={ptBr}
            onChangeRaw={(event) => {
                onChange(event.target.value);
            }}
            onChange={(data) => {
                onChange(moment(data).format('DD/MM/YYYY'));
            }}
            dateFormat="dd/MM/yyyy"
            maxDate={maxDate || undefined}
            autoComplete={autoComplete}
            placeholderText={label}
            popperPlacement="bottom-start"
            popperProps={{ strategy: 'fixed' }}
            withPortal={withPortal}
            customInput={labelExterno ?
                <CustomInputLabelExterno
                    required={required}
                    disabled={disabled}
                    id={id}
                    inputName={inputName}
                    label={label}
                    readOnly={readOnly}
                    title={title}
                    placeholder={placeholder}
                    className={className}
                    autoComplete={autoComplete || "off"}
                    inputStyle={inputStyle}
                /> : <CustomInput
                    required={required}
                    disabled={disabled}
                    id={id}
                    inputName={inputName}
                    label={label}
                    readOnly={readOnly}
                    title={title}
                    placeholder={placeholder}
                    className={className}
                    autoComplete={autoComplete || "off"}
                />
            }
        />
    );
}
